import { observer } from 'mobx-react';
import { Chip, Typography } from '@execonline-inc/execonline-ui';
import MultiStepLearningIcon from '../Icons/MultiStepLearningIcon';
import { T } from '../../../../../../../../Translations';

function ProgramSequenceProductBadge() {
  return (
    <Chip className="bg-muted/50">
      <Typography className="flex items-center gap-x-2 text-foreground" variant="caption">
        <MultiStepLearningIcon size="md" />
        <T kind="Multi Step Learning Journey" />
      </Typography>
    </Chip>
  );
}

export default observer(ProgramSequenceProductBadge);
